import { render, staticRenderFns } from "./luckyredpacketrecord.vue?vue&type=template&id=1b9bb8df"
import script from "./luckyredpacketrecord.vue?vue&type=script&lang=js"
export * from "./luckyredpacketrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports